var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B1B19B93-584B-457E-B379-FE1EA7BDD5E1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC6F\\u200D\\u2640\\uFE0F-11-Creating-Groups",
    stroke: "none",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11-Creating-Groups-Filled-Part",
    transform: "translate(-898.000000, -155.000000)",
    stroke: "white",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(349.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Close",
    transform: "translate(550.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,7.95094105 L15.2909785,0.659962503 L8,7.95094105 L0.709021454,0.659962503 L8,7.95094105 Z M8,7.95094105 L15.767845,15.718786 L8,7.95094105 L0.232155016,15.718786 L8,7.95094105 Z",
    id: "Line-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.aac45ff42de2ba9d8b88ecbdd646b143.svg";
export { ForwardRef as ReactComponent };